<!--  -->
<template>
  <div class="browse">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in column"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        align="center"
        show-overflow-tooltip
        :width="item.width"
      ></el-table-column>
      <el-table-column label="牵星中的链接地址" width="150">
        <template slot-scope="scope">
          <a :href="'//' + url + scope.row.bidid" target="_blank">{{
            url + scope.row.bidid
          }}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
import tool from '../../tool/tool'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      url: 'www.qxchuhai.com/detail?id=',
      tableData: [],
      column: [
        {
          label: '原文标题',
          prop: 'othertitle',
        },
        {
          label: '中文标题',
          prop: 'chinesetitle',
        },
        {
          label: '所属国家',
          prop: 'nationalFlag.chinesecountry',
        },
        {
          label: '发布时间',
          prop: 'reletime',
          width: 98,
        },
        {
          label: '采购单位',
          prop: 'didcustomer',
        },
        {
          label: '原文内容（摘要）',
          prop: 'noticeText.otherlanguage',
        },
        {
          label: '中文内容（摘要）',
          prop: 'noticeText.chinesetext',
        },
      ],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getTable() {
      //行业
      let params = this.$qs.stringify({
        userid: tool.getCookie('user'),
        excelcode: this.$route.query.excelcode,
      })
      this.axios
        .post(API_1 + Global.browse, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.tableData = res.data.data
          } else if (res.data.status == 2) {
            this.$message({
              message: '您的筛选结果已过期，请重新进行筛选。',
              type: 'warning',
              offset: 100,
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 100,
            })
          }
        })
        .catch((res) => {
          this.$message({
            message: '网络连接失败，请刷新重试',
            type: 'error',
            offset: 100,
          })
        })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTable()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.browse {
  padding: 0 !important;
}
</style>
